import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Paper, Box, Avatar, Typography, Grid, Link } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as DefaultLogo } from '../../../../assets/images/default-logo.svg';
import { ReactComponent as EditIcon } from '../../../../assets/images/edit.svg';
import { CustomButton } from '../../../../components/CustomButton';
import { OrgTree } from '../../components/OrgTree';
import { ROUTES, ROUTE_FOR_ASSETS } from '../../../../constants/routes';
import {
  getCompanyBranches,
  getDepartmentsOfBranch,
  getCompany
} from '../../../../store/company/actions';

export const Company = () => {
  const dispatch = useDispatch();

  const currentUserState = useSelector((state) => state.currentUser);
  const { userData: userInfo } = currentUserState;

  const companyState = useSelector((state) => state.company);
  const { companyInfo, branches: branchesOptions } = companyState;

  useEffect(() => {
    dispatch(getCompany());
    dispatch(getCompanyBranches());
  }, [dispatch]);

  useEffect(() => {
    if (userInfo.branch_id) {
      dispatch(getDepartmentsOfBranch(userInfo.branch_id));
    }
  }, [dispatch, userInfo.branch_id]);

  return (
    <Box>
      <Typography mb="16px" variant="h1" sx={{ color: 'text.primary' }} component="h1">
        Моя компания
      </Typography>

      <Paper
        sx={{
          padding: '32px',
          marginBottom: '16px'
        }}>
        <Box
          sx={{
            display: 'flex'
          }}>
          <Avatar
            alt={companyInfo?.name}
            src={`${ROUTE_FOR_ASSETS}${companyInfo.logo}`}
            sx={{ width: 128, height: 128, marginRight: '32px' }}
          >
            {!companyInfo.logo && <DefaultLogo />}
          </Avatar>

          <Box
            sx={{
              width: '100%',
              display: 'flex'
            }}>
            <Box
              sx={{
                width: '100%',
                maxWidth: '370px',
                display: 'flex',
                flexDirection: 'column'
              }}>
              <Typography variant="h1" mb="8px">
                {companyInfo?.name}
              </Typography>
              <Typography variant="subtitle2" component="p" mb="24px">
                {companyInfo?.bin}
              </Typography>
              <Box sx={{ display: 'flex' }}>
                <Box>
                  <CustomButton
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ marginRight: '16px' }}
                    startIcon={<EditIcon />}
                    component={RouterLink}
                    to={ROUTES.EDIT_COMPANY}>
                    Редактировать
                  </CustomButton>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
      <Paper
        sx={{
          padding: '24px'
        }}>
        <Grid container>
          <Grid item xs={3}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}>
              <Typography variant="body1" color="text.secondary">
                Контактное лицо
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 500
                }}>
                {companyInfo?.contact_person}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}>
              <Typography variant="body1" color="text.secondary">
                Город
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 500
                }}>
                {companyInfo?.city}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}>
              <Typography variant="body1" color="text.secondary">
                Номер телефона
              </Typography>
              {companyInfo?.phones?.map((phone) => (
                <Typography
                  key={phone}
                  variant="subtitle2"
                  sx={{
                    fontWeight: 500
                  }}>
                  +7{phone}
                </Typography>
              ))}
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}>
              <Typography variant="body1" color="text.secondary">
                Email
              </Typography>
              <Link
                href="mailto:myemail@gmail.com"
                variant="subtitle2"
                color="primary.main"
                underline="hover"
                sx={{
                  fontWeight: 500
                }}>
                {companyInfo?.email}
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <Box>
        <Typography mt="24px" mb="16px" variant="subtitle2">
          Оргструктура
        </Typography>
        <OrgTree branches={branchesOptions} />
      </Box>
    </Box>
  );
};
